import type { ReactNode } from 'react';

/** Lade- oder Fehlerhinweis innerhalb eines Hilfethemas. */
export function HilfeHinweis({
  fehler = false,
  children,
}: {
  fehler?: boolean | undefined;
  children: ReactNode;
}) {
  return (
    <p className="text-sm" style={{ color: fehler ? 'var(--danger)' : 'var(--ink-3)' }}>
      {children}
    </p>
  );
}
